<div class="row" *ngIf="entidade.acao">
  <div class="form-group col-12">
    <p class="mb-0 font-weight-bold text-black-50">{{entidade.acao.codigo}} {{entidade.acao.nome}}</p>
    <p class="mb-0 font-weight-bold text-black-50">{{funcao}}</p>
  </div>
</div>
<hr class="mt-1" />
<div class="row">
  <div class="col-4">
    <div class="row">
      <label for="ano" class="col-sm-4 col-md-6 col-lg-4 col-form-label font-weight-bold">EXERCÍCIO:</label>
      <div class="col-sm-8 col-md-6 col-lg-8">
        <select #ano_ [(ngModel)]="anoCorrente" id="ano" class="form-control font-weight-bold"
          (change)="alternarAno(ano_.value)">
          <option [value]="item.ano" *ngFor="let item of listaExercicios">
            {{item.ano}}
          </option>
        </select>
      </div>
    </div>
  </div>
  <div class="col-8 text-right font-weight-bold">
    <p>CUSTO DO EXERCÍCIO: {{totalCustoAnual | number:'1.2-2'}}</p>
  </div>
</div>
<hr />
<div class="row form-group">
  <div class="col-4 mt-3">
    <button #btnAdicionarAcaoFonteRecurso (click)="adicionarAcaoFonteRecurso()" data-toggle="modal"
      data-target="#dialogExecutora" class="btn btn-sm btn-success">
      <img src="assets/img/global/plus.png" alt="adicionar" title="Adicionar" height="16" width="16">
      Adicionar
    </button>
  </div>
</div>
<table class="table table-eddy" *ngIf="lista && lista.length > 0">
  <thead>
    <tr>
      <th scope="col">Fonte recurso</th>
      <th scope="col">Aplicação do recurso</th>
      <th scope="col">Despesa orçamentária</th>
      <th scope="col">Valor</th>
      <th scope="col"></th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of lista; let idx = index">
      <td *ngIf="!item.editavel" style="width: 30%">{{item.recurso.codigo}} {{item.recurso.nome}}</td>
      <td *ngIf="!item.editavel" style="width: 30%">{{item.aplicacao.codigo}} {{item.aplicacao.nome}}</td>
      <td *ngIf="!item.editavel" style="width: 35%">{{item.despesa.codigo}} {{item.despesa.nome}}</td>
      <td *ngIf="!item.editavel" style="width: 220px">{{item.valor | number:'1.2-2'}}</td>
      <td *ngIf="item.editavel" style="width: 30%">
        <p-autoComplete #recurso_ id="recurso" [(ngModel)]="entity.recurso" [forceSelection]="true"
          [autoHighlight]="true" [ngModelOptions]="{standalone: true}" [field]="recursoAutoComplete.conversor"
          [suggestions]="recursoAutoComplete.lista" (completeMethod)="recursoAutoComplete.filtrar($event)"
          inputStyleClass="form-control form-control-sm" minLength="1" [style]="{ width: '100%' }"
          *ngIf="recursoAutoComplete">
          <ng-template let-recurso pTemplate="item">
            {{recurso.codigo}} {{recurso.nome}}
          </ng-template>
        </p-autoComplete>
      </td>
      <td *ngIf="item.editavel" style="width: 30%">
        <p-autoComplete id="aplicacao" [(ngModel)]="entity.aplicacao" [forceSelection]="true" [autoHighlight]="true"
          [ngModelOptions]="{standalone: true}" [field]="aplicacaoAutoComplete.conversor"
          [suggestions]="aplicacaoAutoComplete.lista" (completeMethod)="aplicacaoAutoComplete.filtrar($event)"
          inputStyleClass="form-control form-control-sm" minLength="1" [style]="{ width: '100%' }"
          *ngIf="aplicacaoAutoComplete">
          <ng-template let-aplicacao pTemplate="item">
            {{aplicacao.codigo}} {{aplicacao.nome}}
          </ng-template>
        </p-autoComplete>
      </td>
      <td *ngIf="item.editavel" style="width: 35%">
        <p-autoComplete id="despesa" [(ngModel)]="entity.despesa" [forceSelection]="true" [autoHighlight]="true"
          [ngModelOptions]="{standalone: true}" [field]="despesaAutoComplete.conversor"
          [suggestions]="despesaAutoComplete.lista" (completeMethod)="despesaAutoComplete.filtrar($event)"
          inputStyleClass="form-control form-control-sm" minLength="1" [style]="{ width: '100%' }"
          *ngIf="despesaAutoComplete">
          <ng-template let-despesa pTemplate="item">
            {{despesa.codigo}} {{despesa.nome}}
          </ng-template>
        </p-autoComplete>
      </td>
      <td *ngIf="item.editavel" style="width: 220px">
        <input [(ngModel)]="entity.valor" [ngModelOptions]="{standalone: true}" type="text" style="width: 120px;"
          class="form-control form-control-sm" unmask="true" [imask]="imaskConfig" id="valor" placeholder="0,00">
      </td>
      <td class="text-right" style="min-width: 150px;">
        <button *ngIf="!item.editavel" #btnsEditar (click)="editarAcaoFonteRecurso(item)" data-toggle="modal"
          data-target="#dialogExecutora" class="btn btn-sm btn-outline-primary mr-2">
          <img src="assets/img/global/pencil.png" alt="editar" height="16" width="16">
        </button>
        <button *ngIf="!item.editavel" (click)="confirmarRemocao(item, idx)"
          class="btn btn-sm btn-outline-primary mr-2">
          <img src="assets/img/global/bin_closed.png" alt="remover" height="16" width="16">
        </button>
        <button *ngIf="item.editavel" (click)="salvarAcaoFonteRecurso(item)"
          class="btn btn-sm btn-outline-secondary mr-2">
          <img src="assets/img/global/tick.png" alt="salvar" height="16" width="16">
        </button>
        <button *ngIf="item.editavel" (click)="cancelarAcaoFonteRecurso(item, idx)"
          class="btn btn-sm btn-outline-primary mr-2">
          <img src="assets/img/global/cross.png" alt="cancelar" height="16" width="16">
        </button>
      </td>
    </tr>
  </tbody>
</table>
<div class="row">
  <div class="col-9 font-weight-bold">
    <span *ngIf="lista && lista.length > 0">TOTAL:
      {{totalCustoDetalhado | number:'1.2-2' }}</span>
  </div>
</div>